import IZoneCombination = ZoneIQCalibration.IZoneCombination;
import * as _ from 'lodash';
import { IMapper } from '../interfaces/mappers/mapper';

export class ZoneCombinationMapper implements IMapper<IZoneCombination, IZoneCombination> {
    entityProperties = [
        'Id',
        'ZoneId',
        'SubZoneId',
        'ZoneTypeId',
        'RevisionId',
        'GridicsId',
        'IsNotCalibrated',
        'CalibrationErrorMessage',
        'IsPlannedDevelopment',
        'CloneId',
        'BuildingTypologyMandatory',
        'DefaultBuildingTypology',
        'BuildingTypologyIds',
        'BuildingTypologyData',
        'isValidBuildingTypology',
        'Description',
        'IsNotCalibratedReason',
        'Name'
    ];

    dtoProperties = [
        'Id',
        'ZoneId',
        'SubZoneId',
        'ZoneTypeId',
        'RevisionId',
        'GridicsId',
        'IsNotCalibrated',
        'IsPlannedDevelopment',
        'CloneId',
        'BuildingTypologyMandatory',
        'DefaultBuildingTypology',
        'Description'
    ];

    fromDTO(dto: IZoneCombination): IZoneCombination {
        if (!dto) {
            return null;
        }
        const result = _.pick(dto, this.entityProperties);
        result.IsNotCalibrated = !!result.IsNotCalibrated;
        result.IsPlannedDevelopment = !!result.IsPlannedDevelopment;

        return result as IZoneCombination;
    }

    toDTO(entity: IZoneCombination): IZoneCombination {
        if (!entity) {
            return null;
        }
        const result = _.pick(entity, this.dtoProperties);

        return result as IZoneCombination;
    }
}

export function zoneCombinationMapperFactory(): IMapper<IZoneCombination, IZoneCombination> {
    return new ZoneCombinationMapper();
}
